import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as Actions from '../../redux/actions/';
import FeatureGrid from './feature-grid';
import AddFeature from '../add-feature/'
import { mapFeaturesToGridData } from '../../selectors';
import { getFeatures } from "../../api/";

const FeatureList = ({addNotification, features, allFeaturesLoaded, appendFeatures, gridData, lastFeatureDocument, setFeatures, setAllFeaturesLoaded, setLastFeatureDocument}) => {
	const [selectedFeature, setSelectedFeature] = useState(null);
	const [isFetchingFeatures, setIsFetchingFeatures] = useState(false);
	const pageSize = 25;

	useEffect(() => {
		async function fetchFeatures () {
			if ((!features.length || lastFeatureDocument === null) && !isFetchingFeatures) {
				setIsFetchingFeatures(true);
				const allFeaturesCollection = await getFeatures(pageSize);
				const allFeatures = allFeaturesCollection.data;

				allFeaturesCollection.lastDocument && setLastFeatureDocument(allFeaturesCollection.lastDocument);

				if (allFeatures.length < pageSize) {
					setAllFeaturesLoaded(true);
				}

				setFeatures(allFeatures);
				setIsFetchingFeatures(false);
			}
		}
		fetchFeatures();
	}, [features, appendFeatures, isFetchingFeatures, lastFeatureDocument, pageSize, setAllFeaturesLoaded, setFeatures, setIsFetchingFeatures, setLastFeatureDocument]);

	async function handleGridScroll () {
		if (!isFetchingFeatures && lastFeatureDocument) {
			setIsFetchingFeatures(true);
			const moreFeaturesCollection = await getFeatures(pageSize, lastFeatureDocument);
			const moreFeatures = moreFeaturesCollection.data;

			if (moreFeaturesCollection.lastDocument) {
				setLastFeatureDocument(moreFeaturesCollection.lastDocument);
				appendFeatures(moreFeatures);
			}

			if (moreFeatures.length < pageSize) {
				setAllFeaturesLoaded(true);
			}

			setIsFetchingFeatures(false);
		}
	}

	const handleFeatureExit = () => {
		setSelectedFeature(false);
	};

	const handleFeatureSubmit = () => {
		setSelectedFeature(false);
	}

	return (
		<div className="admin-app-page">
			<FeatureGrid
				features={gridData}
				isLoading={!(gridData && features.length)}
				length={allFeaturesLoaded ? features.length : features.length + pageSize}
				onNext={handleGridScroll}
				hasMore={!allFeaturesLoaded}
			/>
			{selectedFeature &&
				<AddFeature
					featureData={selectedFeature}
					onSubmit={handleFeatureSubmit}
					onExit={handleFeatureExit}
				/>
			}
		</div>
	);
};

FeatureList.propTypes = {
	addNotification: PropTypes.func,
	allFeaturesLoaded: PropTypes.bool,
	appendFeatures: PropTypes.func,
	features: PropTypes.array,
	gridData: PropTypes.array,
	lastFeatureDocument: PropTypes.object,
	setAllFeaturesLoaded:PropTypes.func,
	setLastFeatureDocument: PropTypes.func
};

const mapStateToProps = state => {
  return {
    features: state.features,
		allFeaturesLoaded: state.allFeaturesLoaded,
		gridData: mapFeaturesToGridData(state),
		lastFeatureDocument: state.lastFeatureDocument
  }
}

const mapDispatchToProps = {
	appendFeatures: Actions.appendFeatures,
	addNotification: Actions.addNotification,
	setFeatures: Actions.setFeatures,
	setAllFeaturesLoaded: Actions.setAllFeaturesLoaded,
	setLastFeatureDocument: Actions.setLastFeatureDocument
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(FeatureList)
